import type { ErrorMap } from '@/app/error-registry';

export const PROFILE_ERROR_MAP: ErrorMap = {
  PATCH: {
    'User.NotFound': 'settings:apiErrors.userNotFound',
    'User.Deactivated': 'settings:apiErrors.userDeactivated',
    default: 'settings:apiErrors.profileUpdateDefault',
  },
  DELETE: {
    default: 'settings:apiErrors.avatarDeleteDefault',
  },
};
